/*
Properties
General appearance:
    showFrameBorder
    showFrameBackground
    showPlotBorder
    showPlotBackground

Marker symbols:
	setMarkerX(im,xx)
	setMarkerY(im,xx)
	setMarkerXY(im,xx,yy)
	hideAllMarkers()
	setMarkerVisible(im, vis)
	getMarkerVisible(im)
	setMarkerColor(im, col)
	setMarkerStyle(im, style)  "diamond"  "+"  "X"
    showMarkers         boolean

Marker labels appear to the right of each marker point:
    showMarkers
    markerLabelFont        "20px Arial"  Common to all markers
    markerLabelColor                     Common to all markers
    markerLabelRotation                  Common to all markers
    setMarkerLabelText(i, string)
    setMarkerLabelVisible(i, boolean);
    hideAllMarkerLabels()

Axis legends:
	legendFont
    labelsFont
	xAxisLegendText = xAxisLegendTextL
	yAxisLegendText = yAxisLegendTextL
    xAxisLegendTextR
    yAxisLegendTextR
	showXAxisLegend
	showYAxisLegend
Grid:
	xGridSpacing
	yGridSpacing
	showXGridLines
	showYGridLines

Axis value labels:
	xValueLabelSpacing
	yValueLabelSpacing
    xLabelsDecimalPlaces
    yLabelsDecimalPlaces
	showXAxisValueLabels
	showYAxisValueLabels

	useScope.  true = show scope and set xmin = 0 and xmax = scopeTStep * scopeNptsSeg
	plotWidth
	plotHeight
	leftMargin
	rightMargin
	bottomMargin
	topMargin
    xPixelsMin
    yPixelsMin
	frameBackgroundColor
	plotBackgroundColor
	
Curves
	setCurveLegend( iLegend, vis, txt, xpos, ypos )
	clearCurveLegends()
	setPlotLimits(xmin, xmax, ymin, ymax)
	setCurveColor(i, color)
    curveThickness or curveThicknessL
    curveThicknessR
	loadCurve(ic, xVals, yVals)
	drawCurve(iCurve)
	clearCurve(iCurve)
    setCurveVisible(ic, vis)
    curveIsOnLeft
	
	*/


import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import { StringKeyframeTrack, AudioAnalyser } from "three";
import Oscilloscope4 from "SATPROF_UTILS/Oscilloscope4"; 

export default class XYPlot_p extends AnimateProxyBase{
 
    private animateSpace:AnimateRenderSpace
        // These define the plot box area in pixels. Same for L and R.
		private _plotWidth = 400;
		private _plotHeight = 400;
		private _leftMargin = 70;
		private _rightMargin = 20;
		private _bottomMargin = 50;
		private _topMargin = 20;
		private _xPixelsMax = 380;
		private _xPixelsMin = 80;
		private _yPixelsMax = 20;
		private _yPixelsMin = 350;
		
		private _xMinL = -5;
		private _xMaxL = 5;
		private _yMinL = -10;
		private _yMaxL = 60;
		private _xMinGridL = this._xMinL;
		private _xMaxGridL = this._xMaxL;
		private _yMinGridL = this._yMinL;
		private _yMaxGridL = this._yMaxL;

		private _xMinR = -5;
		private _xMaxR = 5;
		private _yMinR = -20;
		private _yMaxR = 90;
		private _xMinGridR = this._xMinR;
		private _xMaxGridR = this._xMaxR;
		private _yMinGridR = this._yMinR;
		private _yMaxGridR = this._yMaxR;        

		private _xGridSpacingL = 1;
		private _yGridSpacingL = 5;


		private _xGridSpacingR = 1;
		private _yGridSpacingR = 10;

		private _useScope = false;
        public scope:Oscilloscope4;
		
		private BG:createjs.Shape;
		private plotArea:createjs.Container;
		private legendsArea:createjs.Container;
		public plotBG:createjs.Shape;
		private _maskArea:createjs.Shape;
		private xGridLinesL:createjs.Shape;
		private yGridLinesL:createjs.Shape;
		private _showXGridLinesL:boolean = true;
		private _showYGridLinesL:boolean = true;
		private  _gridLineColorL:string = "gray";
		private xGridLinesR:createjs.Shape;
		private yGridLinesR:createjs.Shape;
		private _showXGridLinesR:boolean = false;
		private _showYGridLinesR:boolean = false;
		private  _gridLineColorR:string = "green";
        private _showFrameBorder:boolean = true;
        private _showFrameBackground:boolean = true; 
        private _showPlotBorder:boolean = true; 
        private _showPlotBackground:boolean = true;         
		private _markerShape:Array<createjs.Shape>;
		private _markerVisible:Array<boolean>;
		private _markerColor:Array<string>;
		private _markerSize:Array<number>;
		private _markerStyle:Array<string>;
		private _markerX:Array<number>;
		private _markerY:Array<number>;
        private _maxMarkers:number = 500;

		private _markerLabel:Array<createjs.Text>;
		private _markerLabelFont:string = "20px Arial";
		private _markerLabelColor:string = "black";
		private _markerLabelRotation:number = 0;
		private _markerLabelText:Array<string>;
		private _markerLabelVisible:Array<boolean>;
        

        // Theres is only one set of curves.  A given curve can be associated with the left or right side axis.
        // The x and y data for each curve must be in _xValues and _yValues
        private _curveIsOnLeft:Array<boolean>;
        private _markerIsOnLeft:Array<boolean>;
		private curves:Array<createjs.Shape>;
		private _xValues:Array<Array<number>>;
		private _yValues:Array<Array<number>>;
		private _curveStyle:Array<string>;
		private _curveThicknessL = 1;
		private _curveStyleR:Array<string>;
		private _curveThicknessR = 1;

		private _FrameBackgroundColor:string = "lightyellow";
		private _frameBackgroundAlpha:number = 1;
		private _frameBorderColor:string = "black";
		private _plotBackgroundColor:string = "white";
		private _plotBackgroundAlpha:number = 1;
        private _maxCurves:number = 20;
		private curveColor:Array<string>;
        private _drawBoxesAroundTexts:boolean = true;
		private xAxisLegendL:createjs.Text;
		private yAxisLegendL:createjs.Text;
		private xAxisLegendR:createjs.Text;
		private yAxisLegendR:createjs.Text;
		private xAxisValueLabelsL:Array<createjs.Text>;
		private xAxisValueLabelsR:Array<createjs.Text>;
        private _xAxisLegendHeight:number = 30;
        private _yAxisValueLabelsWidthR:number = 40;
        private _yAxisLegendHeightR:number = 15;
        private _yAxisValueLabelsWidthL:number = 40;
        private _yAxisLegendHeightL:number = 15;        
		private _legendFont:string = "16px Arial"; // "16px Arial";
		private _labelsFont:string = "14px Arial";
		private _xLabelsDecimalPlacesL = 1;
		private _yLabelsDecimalPlacesL = 2;
		private _xLabelsDecimalPlacesR = 1;
		private _yLabelsDecimalPlacesR = 2;        
		private _showXAxisValueLabelsL = true;
		private _showYAxisValueLabelsL = true;
		private _showXAxisValueLabelsR = false;
		private _showYAxisValueLabelsR = false;        
		private _showXAxisLegendL = true;
		private _showYAxisLegendL = true;
		private _showXAxisLegendR = false;
		private _showYAxisLegendR = false;

		private _xValueLabelSpacingL = 1;
		private _yValueLabelSpacingL = 10;
		private _xValueLabelSpacingR = 1;
		private _yValueLabelSpacingR = 10;        
		private _xAxisLegendTextL = "Angle from target along geo arc";
		private _yAxisLegendTextL = "EIRP Spectral Density, dBW/40kHz";
		private _xAxisLegendTextR = "Right axis X legend";
		private _yAxisLegendTextR = "Right axis Y legend";        
		private _curveLegendText:Array<string>;
		private _curveLegendColor:Array<string>;
		private _curveLegendX:Array<number>;
		private _curveLegendY:Array<number>;
		private _legendFontSize = 20;
		private _accumulate = false;
		private _showLines = true;
		private _showSymbols = false;
		private _symbolSize = 3;
        private _showTextBoxes:boolean = false; // For text position debugging
        private _showCurveLegends:boolean = false; // Default.  Enable with setter.
        private _showMarkers:boolean = false; 

	public ready:boolean = false;

    onFrameZero(){
        //console.log("In XYPlot_p.onFrameZero()");
        super.onFrameZero();

        this.animateSpace = this.extraData.animateSpace;       

        this.initialize();

    }
	public initialize(){
		// Put all remaining init code here.
        //console.log("In XYplot_p. Initializing...");
        // Put code that depends on the symbol being on stage here.
        
        this.stageSymbol.icon.visible = false;
        let i:number;
        
        this._xValues = [];
        this._yValues = [];      
        this.recalcLimits();
        
        this.BG = new createjs.Shape();
        this.drawFrameBG();
        
        this.scope = new Oscilloscope4();
        this.scope.marginPct = 0;
        this.scope.visible = this._useScope;


        this.plotArea = new createjs.Container();
        this._maskArea = new createjs.Shape();
        this.plotArea.mask = this._maskArea;
        
        
        this.legendsArea = new createjs.Container();
        
        this.plotBG = new createjs.Shape();
        this.drawplotBG();
        
        
        this.xGridLinesL = new createjs.Shape();
        this.yGridLinesL = new createjs.Shape();
        this.xGridLinesR = new createjs.Shape();
        this.yGridLinesR = new createjs.Shape();        
        this.drawGridlines();

        this.stageSymbol.addChild(this.BG);
        this.stageSymbol.addChild(this.plotBG);
        this.stageSymbol.addChild(this.scope);
        this.stageSymbol.addChild(this.plotArea);
        this.stageSymbol.addChild(this.xGridLinesL);
        this.stageSymbol.addChild(this.yGridLinesL);
        this.stageSymbol.addChild(this.xGridLinesR);
        this.stageSymbol.addChild(this.yGridLinesR);        
        this.stageSymbol.addChild(this._maskArea);
        this.stageSymbol.addChild(this.legendsArea);

        this.curves = [];
        this.curveColor = [];
        this._curveStyle = [];
        this._curveIsOnLeft = [];
        this._markerIsOnLeft = [];
        for ( i=0; i<this._maxCurves; i++){
            this.curves[i] = new createjs.Shape();
            this.plotArea.addChild(this.curves[i]);
            this.curveColor[i] = "#00FF00";
            this._curveStyle[i] = "linesOnly";
            this._curveIsOnLeft[i] = true;
            //console.log("Init i = "+i+" _curveStyle[i] = "+_curveStyleL[i]);
        }
        
        this._markerShape = [];
        this._markerVisible = [];
        this._markerColor = [];
        this._markerSize = [];
        this._markerStyle = [];
        this._markerX = [];
        this._markerY = [];
        this._markerLabel = [];
        this._markerLabelText = [];
        this._markerLabelVisible = [];
        this._markerLabelFont =  "bold 36px Arial";
        this._markerLabelColor = "blue";
        for ( i=0; i<this._maxMarkers; i++){
            this._markerShape[i] = new createjs.Shape();
            this._markerShape[i].name = i.toFixed(0);
            this._markerVisible[i] = false;
            this._markerColor[i] = UtilSP.c2rgba("red");
            this._markerSize[i] = 10;
            this._markerStyle[i] = "diamond"; //"+"  "X"; //
            this._markerX[i] = 0;
            this._markerY[i] = 0;
            this.plotArea.addChild(this._markerShape[i]);
            this._markerIsOnLeft[i] = true; 

            //this._markerShape[i].mouseChildren = false;
            this._markerShape[i].addEventListener("mouseover", this.mouseOverHandler.bind(this));
            this._markerShape[i].addEventListener("mouseout", this.mouseOutHandler.bind(this));


            this._markerLabel[i] = new createjs.Text();
            this.plotArea.addChild(this._markerLabel[i]);
            this._markerLabelText[i] = "";
            this._markerLabelVisible[i] = false;
        }
        this.drawMarkers();
                            
        this._curveLegendText = [];
        this._curveLegendColor = [];
        this._curveLegendX = [];
        this._curveLegendY = [];
        /*
        _curveLegendText[0] = "ITU";
        _curveLegendX[0] = -4;
        _curveLegendY[0] = 30;
        _curveLegendText[1] = "FCC";
        _curveLegendX[1] = -3;
        _curveLegendY[1] = 20;
        */
        this.rebuild();	

       	this.ready = true;

    }  
    
    onRequestAnimFrame(timingInfo : TimingInfo) {
        // Do every frame

    } 
    private mouseOverHandler(evt:any){
        console.log("Mouseover "+ evt.target.name);
        const event = new CustomEvent('ROLLOVERXYPLOTLABEL', { detail:{name:"XYPlot", myvalue:evt.target.name} });
        window.dispatchEvent(event);
        //debugger
    }
    private mouseOutHandler(evt:any){
        console.log("Mouseout "+ evt.target.name);
        const event = new CustomEvent('ROLLOUTXYPLOTLABEL', { detail:{name:"XYPlot", myvalue:evt.target.name} });
        window.dispatchEvent(event);        
    }    
    public x2pixelsL(xx:number){
        let retval:number = this._xPixelsMin + (xx-this._xMinGridL)*(this._xPixelsMax-this._xPixelsMin)/(this._xMaxGridL-this._xMinGridL);
        //console.log("in x2pixelsL, xx = "+xx+", _xPixelsMin = "+this._xPixelsMin+", _xPixelsMax = "+this._xPixelsMax+
        //", _xMinGridL = "+this._xMinGridL+", _xMaxGridL = "+this._xMaxGridL+", retval = "+retval);
        return retval;
    }
    public y2pixelsL(yy:number){
        let retval:number =  this._yPixelsMin + (yy-this._yMinGridL)*(this._yPixelsMax-this._yPixelsMin)/(this._yMaxGridL-this._yMinGridL);
        //console.log("   "+retval);
        //console.log("in y2pixelsL, yy = "+yy+", _yPixelsMin = "+this._yPixelsMin+", _yPixelsMax = "+this._yPixelsMax+
        //", _yMinGridL = "+this._yMinGridL+", _yMaxGridL = "+this._yMaxGridL+", retval = "+retval);        
        return retval;
    }
    public x2pixelsR(xx:number){
        //console.log("in x2pixelsR, xx = "+xx+", _xPixelsMin = "+this._xPixelsMin+", _xPixelsMax = "+this._xPixelsMax+
        // ", _xMinGridR = "+this._xMinGridR+", _xMaxGridR = "+this._xMaxGridR);
        return this._xPixelsMin + (xx-this._xMinGridR)*(this._xPixelsMax-this._xPixelsMin)/(this._xMaxGridR-this._xMinGridR);
    }
    public y2pixelsR(yy:number){
        let retval:number =  this._yPixelsMin + (yy-this._yMinGridR)*(this._yPixelsMax-this._yPixelsMin)/(this._yMaxGridR-this._yMinGridR);
        //console.log("   "+retval);
        return retval;
    }    
    private recalcLimits(){
        this._xPixelsMin = this._leftMargin;
        this._xPixelsMax =  this._plotWidth - this._rightMargin;
        this._yPixelsMax = this._topMargin;
        this._yPixelsMin =  this._plotHeight - this._bottomMargin;

        this._xMinGridL = this._xGridSpacingL*Math.floor(this._xMinL/this._xGridSpacingL);
        this._xMaxGridL = this._xGridSpacingL*Math.ceil(this._xMaxL/this._xGridSpacingL);
        this._yMinGridL = this._yGridSpacingL*Math.floor(this._yMinL/this._yGridSpacingL);
        this._yMaxGridL = this._yGridSpacingL*Math.ceil(this._yMaxL/this._yGridSpacingL);

        this._xMinGridR = this._xGridSpacingR*Math.floor(this._xMinR/this._xGridSpacingR);
        this._xMaxGridR = this._xGridSpacingR*Math.ceil(this._xMaxR/this._xGridSpacingR);
        this._yMinGridR = this._yGridSpacingR*Math.floor(this._yMinR/this._yGridSpacingR);
        this._yMaxGridR = this._yGridSpacingR*Math.ceil(this._yMaxR/this._yGridSpacingR);        
        //console.log("In XYplot.recalcLimits(): _xMinL = "+this._xMinL+", _xMinGridL = "+this._xMinGridL+", _xMaxL = "+this._xMaxL+", _xMaxGridL = "+this._xMaxGridL+", _xGridSpacingL = "+this._xGridSpacingL);
        //console.log("In XYplot.recalcLimits(): _yMaxGridR = "+this._yMaxGridR+", _yMaxR = "+this._yMaxR+", _yGridSpacingR = "+this._yGridSpacingR);
        //console.log("In XYplot.recalcLimits(): _yMinGridR = "+this._yMinGridR+", _yMinR = "+this._yMinR+", _yGridSpacingR = "+this._yGridSpacingR);
        if (isNaN(this._yMaxGridR)){
            debugger;
        }
        
    }

    //* Public methods and properties:
    public set xGridSpacing(g:number){
        this._xGridSpacingL = g;
        this.rebuild();
    }
    public get xGridSpacing(){ return this._xGridSpacingL; };

    public set xGridSpacingR(g:number){
        this._xGridSpacingR = g;
        this.rebuild();
    }
    public get xGridSpacingR(){ return this._xGridSpacingR; };

    public set showFrameBorder(val:boolean){
        this._showFrameBorder = val;
        this.rebuild();
    }
    public get showFrameBorder(){
        return this._showFrameBorder;
    }
    public set showFrameBackground(val:boolean){
        this._showFrameBackground = val;
        this.rebuild();
    }
    public get showFrameBackground(){
        return this._showFrameBackground;
    }

    public set showPlotBorder(val:boolean){
        this._showPlotBorder = val;
        this.rebuild();
    }
    public get showPlotBorder(){
        return this._showPlotBorder;
    }
    public set showPlotBackground(val:boolean){
        this._showPlotBackground = val;
        this.rebuild();
    }
    public get showPlotBackground(){
        return this._showPlotBackground;
    }

    public set showXGridLines(val:boolean){
        this._showXGridLinesL = val;
        this.rebuild();
    }
    public get showXGridLines(){
        return this._showXGridLinesL;
    }
    public set showXGridLinesR(val:boolean){
        this._showXGridLinesR = val;
        this.rebuild();
    }
    public get showXGridLinesR(){
        return this._showXGridLinesR;
    }    
    public set showYGridLines(val:boolean){
        this._showYGridLinesL = val;
        this.rebuild();
    }
    public get showYGridLines(){
        return this._showYGridLinesL;
    }
    public set showYGridLinesR(val:boolean){
        this._showYGridLinesR = val;
        this.rebuild();
    }
    public get showYGridLineR(){
        return this._showYGridLinesR;
    }    
    public set gridLineColor(g:string){
        this._gridLineColorL = UtilSP.c2rgba(g);
        this.rebuild();
    }
    public get gridLineColor(){ return this._gridLineColorL; };

    public set gridLineColorR(g:string){
        this._gridLineColorR = UtilSP.c2rgba(g);
        this.rebuild();
    }
    public get gridLineColorR(){ return this._gridLineColorL; };    

    public set xValueLabelSpacing(g:number){
        this._xValueLabelSpacingL = g;
        this.writeLegends()
    }
    public get xValueLabelSpacing(){ return this._xValueLabelSpacingL; };

    public set xValueLabelSpacingR(g:number){
        this._xValueLabelSpacingR = g;
        this.writeLegends()
    }
    public get xValueLabelSpacingR(){ return this._xValueLabelSpacingR; }; 

    public set yGridSpacing(g:number){
        this._yGridSpacingL = g;
        this.rebuild();
    }
    public get yGridSpacing(){ return this._yGridSpacingL; };

    public set yGridSpacingR(g:number){
        this._yGridSpacingR = g;
        console.log("in set yGridSpacingR = "+this._yGridSpacingR)
        this.rebuild();
    }
    public get yGridSpacingR(){ return this._yGridSpacingR; };

    public set yValueLabelSpacing(g:number){
        this._yValueLabelSpacingL = g;
        this.writeLegends()
    }
    public get yValueLabelSpacing(){ return this._yValueLabelSpacingL; };

    public set yValueLabelSpacingR(g:number){
        this._yValueLabelSpacingR = g;
        this.writeLegends()
    }
    public get yValueLabelSpacingR(){ return this._yValueLabelSpacingR; };   
    
    public set plotWidth(w){
        this._plotWidth = w;
        this.rebuild();
    }
    public get plotWidth(){ return this._plotWidth; };
    
    public set plotHeight(w){
        this._plotHeight = w;
        this.rebuild();
    }
    public get plotHeight(){ return this._plotHeight; };
    
    
    public set accumulate(val:boolean){
        this._accumulate = val;
    }
    public get accumulate(){
        return this._accumulate;
    }
    public set leftMargin(val){
        this._leftMargin = val;
        this.rebuild();
    }
    public get leftMargin(){
        return this._leftMargin;
    }
    public set rightMargin(val){
        this._rightMargin = val;
        this.rebuild();
    }
    public get rightMargin(){
        return this._rightMargin;
    }
    public set bottomMargin(val){
        this._bottomMargin = val;
        this.rebuild();
    }
    public get bottomMargin(){
        return this._bottomMargin;
    }
    public set topMargin(val){
        this._topMargin = val;
        this.rebuild();
    }
    public get topMargin(){
        return this._topMargin;
    }
    public set frameBackgroundColor(val:string){
        this._FrameBackgroundColor = val;
        this.rebuild();
    }
    public get frameBackgroundColor(){
        return this._FrameBackgroundColor;
    }
    public set frameBorderColor(val:string){
        this._frameBorderColor = val;
        this.rebuild();
    }
    public get frameBorderColor(){
        return this._frameBorderColor;
    }
    public set plotBackgroundColor(val:string){
        this._plotBackgroundColor = val;
        this.rebuild();
    }
    public get plotBackgroundColor(){
        return this._plotBackgroundColor;
    }
    
    public set plotBackgroundAlpha(val){
        this._plotBackgroundAlpha = val;
        this.rebuild();
    }
    public get plotBackgroundAlpha(){
        return this._plotBackgroundAlpha;
    }		
    public set frameBackgroundAlpha(val){
        this._frameBackgroundAlpha = val;
        this.rebuild();
    }
    public get frameBackgroundAlpha(){
        return this._frameBackgroundAlpha;
    }		
    public set symbolSize(val){
        this._symbolSize = val;
    }
    public get symbolSize(){
        return this._symbolSize;
    }
    public set useScope(val){
        this._useScope = val;
        this.scope.visible = this._useScope;
        this.rebuild();
    }
    public get useScope(){
        return this._useScope;
    }
    
    public set legendFont(val:string){
        this._legendFont = val;
        this.writeLegends();
    }
    public get legendFont(){
        return this._legendFont;
    }
    public set labelsFont(val:string){
        this._labelsFont = val;
        this.writeLegends();
    }
    public get labelsFont(){
        return this._labelsFont;
    } 
    public set xLabelsDecimalPlaces(val:number){
        this._xLabelsDecimalPlacesL = val;
        this.writeLegends();
    }
    public get xLabelsDecimalPlaces(){
        return this._xLabelsDecimalPlacesL;
    }    
    public set yLabelsDecimalPlaces(val:number){
        this._yLabelsDecimalPlacesL = val;
        this.writeLegends();
    }
    public get yLabelsDecimalPlaces(){
        return this._yLabelsDecimalPlacesL;
    } 

    public set xLabelsDecimalPlacesR(val:number){
        this._xLabelsDecimalPlacesR = val;
        this.writeLegends();
    }
    public get xLabelsDecimalPlacesR(){
        return this._xLabelsDecimalPlacesR;
    }    
    public set yLabelsDecimalPlacesR(val:number){
        this._yLabelsDecimalPlacesR = val;
        this.writeLegends();
    }
    public get yLabelsDecimalPlacesR(){
        return this._yLabelsDecimalPlacesR;
    } 

    public setCurveLegend( iLegend:number, vis:boolean, txt:string, xpos:number, ypos:number, color?:string ){
        if (!vis){
            this._curveLegendText[iLegend] = "";
            return;
        }
        this._curveLegendText[iLegend] = txt;
        this._curveLegendX[iLegend] = xpos;
        this._curveLegendY[iLegend] = ypos;
        if (typeof color == 'undefined'){
            this._curveLegendColor[iLegend] = "black";
        } else {
            this._curveLegendColor[iLegend] = color;
        }
        this.writeLegends();
    }
    public clearCurveLegends(){
        this._curveLegendText = [];
        this.writeLegends();
    }
    public setPlotLimits(xmin, xmax, ymin, ymax){
        this._xMinL = xmin;
        this._xMaxL = xmax;
        this._yMinL = ymin;
        this._yMaxL = ymax;
        this.rebuild();
    }
    public setPlotLimitsR(xmin, xmax, ymin, ymax){
        this._xMinR = xmin;
        this._xMaxR = xmax;
        this._yMinR = ymin;
        this._yMaxR = ymax;
        this.rebuild();
    }    
    public set yMin(val){
        this._yMinL = val;
        this.rebuild();
    }
    public get yMin(){
        return this._yMinL;
    }
    public set yMax(val){
        this._yMaxL = val;
        this.rebuild();
    }
    public get yMax(){
        return this._yMaxL;
    }
    public set xMin(val){
        this._xMinL = val;
        this.rebuild();
    }
    public get xMin(){
        return this._xMinL;
    }
    public set xMax(val){
        this._xMaxL = val;
        this.rebuild();
    }
    public get xMax(){
        return this._xMaxL;
    }

    public set yMinR(val){
        this._yMinR = val;
        this.rebuild();
    }
    public get yMinR(){
        return this._yMinR;
    }
    public set yMaxR(val){
        this._yMaxR = val;
        this.rebuild();
    }
    public get yMaxR(){
        return this._yMaxL;
    }
    public set xMinR(val){
        this._xMinR = val;
        this.rebuild();
    }
    public get xMinR(){
        return this._xMinL;
    }
    public set xMaxR(val){
        this._xMaxR = val;
        this.rebuild();
    }
    public get xMaxR(){
        return this._xMaxL;
    }    

    public set xPixelsMin(val){
        this._xPixelsMin = val;
        this.writeLegends();
    }
    public get xPixelsMin(){
        return this._xPixelsMin;
    }
    public set yPixelsMin(val){
        this._yPixelsMin = val;
        this.writeLegends();
    }
    public get yPixelsMin(){
        return this._yPixelsMin;
    }
    public loadCurve(ic:number, xVals:Array<number>, yVals:Array<number>){
        this._xValues[ic] = new Array(xVals.length);
        this._xValues[ic] = xVals.concat(); // Clones
        this._yValues[ic] = new Array(yVals.length);
        this._yValues[ic] = yVals.concat();
        //console.log("In loadCurve, ic = "+ic+", _xValues[ic].length = "+this._xValues[ic].length+", _yValues[ic].length = "+this._yValues[ic].length);
   
    }
    public setScopeData1(arr:Array<number>){
        this.scope.loadData1(arr, this.scope.tStep, arr.length);
        this.scope.NptsSeg = arr.length;
        this.rebuild();
    }
    public set scopeTStep(val:number){
        this.scope.tStep = val;
        this.rebuild();
    }
    public get scopeTStep(){
        return this.scope.tStep;
    }
    
    public set scopeNptsSeg(val:number){
        this.scope.NptsSeg = val;
        this.rebuild();
    }
    public get scopeNptsSeg(){
        return this.scope.NptsSeg;
    }
    public set scopeTimeScaleFactor(val){this.scope.timeScaleFactor = val;	};
    public get scopeTimeScaleFactor(){	return this.scope.timeScaleFactor;};
    public set scopeSingleSweep(val){ this.scope.singleSweep = val;	};
    public get scopeSingleSweep(){	return this.scope.singleSweep;};
    public set scopeAutoSweep(val){ this.scope.autoSweep = val;	};
    public get scopeAutoSweep(){	return this.scope.autoSweep;};
    public set scopeAutoUpdate(val){ this.scope.autoUpdate = val;	};
    public get scopeAutoUpdate(){	return this.scope.autoUpdate;};
    public set scopeTrace1Color(val){ this.scope.trace1Color = val;	this.scope.triggerSweep()};
    public get scopeTrace1Color(){	return this.scope.trace1Color;};
    public set scopeDot1Color(val){ this.scope.dot1Color = val;	this.scope.triggerSweep()};
    public get scopeDot1Color(){	return this.scope.dot1Color;};
    
    public scopeSetLabels(i:number, txt:string){
        this.scope.labels[i].text = txt;
        this.scope.updateAllLabelFormats();
    }
    public scopeSetLabelPosPixels(i, xpos, ypos){
        this.scope.setLabelPos(i, xpos, ypos );
    }
    public scopeSetLabelPosValues(i, xpos, ypos){
        this.scope.setLabelPosByValue(i, xpos, ypos );
    }
    public set scopeLabelFont(val:string){
        this.scope.labelFont = val;
        this.scope.updateAllLabelFormats();
    }
    public set scopeLabelColor(val){
        this.scope.labelColor = val;
        this.scope.updateAllLabelFormats();
    }
        

    public scopeTriggerSweep(){
        this.scope.triggerSweep();
    }
    public scopeReset(){
        this.scope.reset();
    }

    public drawCurve(iCurve:number){
        
        if (!this._accumulate){
            this.curves[iCurve].graphics.clear();
        }
        if (this._curveIsOnLeft[iCurve]){
            this.curves[iCurve].graphics.setStrokeStyle(this._curveThicknessL)
        } else {
            this.curves[iCurve].graphics.setStrokeStyle(this._curveThicknessR)
        }
        this.curves[iCurve].graphics.beginStroke( this.curveColor[iCurve]);
        let first = true;
        let i:number;
        let xx:number;
        let yy:number;
        let xp:number, yp:number;
        //console.log("In drawCurve, iCurve = "+iCurve+", color = "+this.curveColor[iCurve]); //+", len = "+this._xValues[iCurve].length);
        if ( this._xValues[iCurve] && (this._curveStyle[iCurve] == "linesOnly" || this._curveStyle[iCurve] == "linesAndSymbols")){
            for (i=0; i<this._xValues[iCurve].length; i++){
                xx = this._xValues[iCurve][i];
                yy = this._yValues[iCurve][i]
                if (first){
                    if (this._curveIsOnLeft[iCurve]){
                        this.curves[iCurve].graphics.moveTo(this.x2pixelsL(xx),  this.y2pixelsL(yy));
                        //console.log("LEFT:  i = "+i+", x= "+xx+", y = "+yy+", y pixels = "+this.y2pixelsL(yy));
                    } else {
                        this.curves[iCurve].graphics.moveTo(this.x2pixelsR(xx),  this.y2pixelsR(yy));
                        //console.log("RIGHT:  i = "+i+", x= "+xx+", y = "+yy+", pixels = "+this.y2pixelsR(yy));
                    }
                    first = false;
                } else {
                    if (this._curveIsOnLeft[iCurve]){
                        this.curves[iCurve].graphics.lineTo(this.x2pixelsL(xx),  this.y2pixelsL(yy) );
                        //console.log("LEFT:  i = "+i+", x= "+xx+", y = "+yy+", y pixels = "+this.y2pixelsL(yy));
                    } else {
                        this.curves[iCurve].graphics.lineTo(this.x2pixelsR(xx),  this.y2pixelsR(yy) );
                        //console.log("RIGHT:  i = "+i+", x= "+xx+", y = "+yy+", pixels = "+this.y2pixelsR(yy));
                    }
                }
            }
        }
        if (this._curveStyle[iCurve] == "symbolsOnly" || this._curveStyle[iCurve] == "linesAndSymbols"){
            for (i=0; i<this._xValues[iCurve].length; i++){
                if (this._xValues[iCurve][i] &&  this._yValues[iCurve][i]){
                    // Point exists
                    //this.curves[iCurve].graphics.lineStyle(); // no line
                    this.curves[iCurve].graphics.beginFill( UtilSP.c2rgba(this.curveColor[iCurve] ));// , 1
                    this.curves[iCurve].graphics.drawCircle( 
                        this.x2pixelsL(this._xValues[iCurve][i]), this.y2pixelsL(this._yValues[iCurve][i]) , this._symbolSize );
                }
            }
        }
    }

    //--------------------------------------------------------------------------------------------
    private rebuild(){
        //console.log("In rebuild()");
        this.recalcLimits();
        this.drawFrameBG();
        this.drawplotBG();
        
        let xw:number = this.x2pixelsL(this._xMaxL) - this.x2pixelsL(this._xMinL);
        let yw:number = -(this.y2pixelsL(this._yMaxL) - this.y2pixelsL(this._yMinL));

        this.scope.screenWidth = xw;
        this.scope.screenHeight = yw;
        this.scope.x = this.x2pixelsL(this._xMinL);
        this.scope.y = this.y2pixelsL(this._yMinL);
        this.scope.regenerateGraphics();
        
        if (this._useScope){
            this._xMinL = 0;
            this._xMaxL = this.scope.tStep * this.scope.NptsSeg;
            this.scope.nVperDiv = this.yGridSpacing;
            this.scope.nVdivs = (this._yMaxL - this._yMinL)/this.yGridSpacing;
            this.scope.nVcenter = (this._yMaxL + this._yMinL)/2;
            //scope.nTperDiv = xGridSpacing;
            this.scope.nTdivs = (this._xMaxL - this._xMinL)/this.xGridSpacing;
            this.scope.gridType = "None";
            this.scope.showScreenBackground = false;
            this.scope.createGrid();
        }

        this.drawGridlines();
        this.updateMarkers();
        this.writeLegends();
        //console.log("In rebuild: _yMinL = "+_yMinL+", _yMaxL = "+_yMaxL+", yGridSpacing = "+yGridSpacing+", _useScope = "+_useScope+", scope: nVdivs = "+scope.nVdivs+", nVcenter = "+scope.nVcenter+", scope.nVperDiv = "+scope.nVperDiv);
    }
    private updateMarkers(){
        //console.log("In updateMarkers, len = "+this._markerShape.length);
        let h:number;
        let d:number;
        let c:number = Math.cos(UtilSP.radians(this._markerLabelRotation));
        let s:number = Math.sin(UtilSP.radians(this._markerLabelRotation));
        for (let i=0; i<this._markerShape.length; i++){
            this._markerShape[i].visible = this._markerVisible[i] && this._showMarkers;
            if (this._markerShape[i].visible){
                if (this._markerIsOnLeft[i]){
                    this._markerShape[i].x = this.x2pixelsL(this._markerX[i]);
                    this._markerShape[i].y = this.y2pixelsL(this._markerY[i]);
                } else {
                    this._markerShape[i].x = this.x2pixelsR(this._markerX[i]);
                    this._markerShape[i].y = this.y2pixelsR(this._markerY[i]);            
                }
                h = this._markerLabel[i].getMeasuredHeight();
                d = h;
                this._markerLabel[i].x = this._markerShape[i].x + d*c + (h/2)*s;
                this._markerLabel[i].y = this._markerShape[i].y + d*s - (h/2)*c;
                //console.log(i+": x = "+this._markerShape[i].x+"/"+this._markerX[i]+", y = "+this._markerShape[i].y+"/"+this._markerY[i]+", vis = "+this._markerVisible[i]+"/"+this._markerShape[i].visible);
            }
        }
    }
    private drawFrameBG(){
        this.BG.graphics.clear();
        //console.log("In drawFrameBG, _frameBorderColor = "+this._frameBorderColor+", this._FrameBackgroundColor = "+this._FrameBackgroundColor);
        if (!this._showFrameBorder && !this._showFrameBackground){
            return;
        }
        if (this._showFrameBorder){
            this.BG.graphics.setStrokeStyle(1);
            this.BG.graphics.beginStroke(this._frameBorderColor);
        }
        if (this._showFrameBackground){
            this.BG.graphics.beginFill(UtilSP.c2rgba(this._FrameBackgroundColor)); //, this._frameBackgroundAlpha
        }
        if (this._showFrameBorder || this._showFrameBackground){
            this.BG.graphics.moveTo(0, 0);
            this.BG.graphics.lineTo(this._plotWidth, 0);
            this.BG.graphics.lineTo(this._plotWidth, this._plotHeight );
            this.BG.graphics.lineTo(0, this._plotHeight );
            this.BG.graphics.lineTo(0, 0);
            this.BG.graphics.endFill();
        }
        return;
    }
    private drawplotBG(){
        //console.log("In drawplotBG, _plotBackgroundColor = "+this._plotBackgroundColor);
        this.plotBG.graphics.clear();
        if (!this._showPlotBorder && !this._showPlotBackground){
            return;
        }        
        if (this._showPlotBorder){
            this.plotBG.graphics.setStrokeStyle(1);
            this.plotBG.graphics.beginStroke(UtilSP.c2rgba("black"));
        }
        if (this._showPlotBackground){
            this.plotBG.graphics.beginFill(UtilSP.c2rgba(this._plotBackgroundColor)); //, this._plotBackgroundAlpha
        }
        if (this._showPlotBorder || this._showPlotBackground){
            this.plotBG.graphics.moveTo(this.x2pixelsL(this._xMinGridL),  this.y2pixelsL(this._yMinGridL));
            this.plotBG.graphics.lineTo(this.x2pixelsL(this._xMinGridL),  this.y2pixelsL(this._yMaxGridL));
            this.plotBG.graphics.lineTo(this.x2pixelsL(this._xMaxGridL),  this.y2pixelsL(this._yMaxGridL));
            this.plotBG.graphics.lineTo(this.x2pixelsL(this._xMaxGridL),  this.y2pixelsL(this._yMinGridL));
            this.plotBG.graphics.lineTo(this.x2pixelsL(this._xMinGridL),  this.y2pixelsL(this._yMinGridL));
            this.plotBG.graphics.endFill();
            this._maskArea.graphics.clear();
            this._maskArea.graphics.moveTo(this.x2pixelsL(this._xMinGridL),  this.y2pixelsL(this._yMinGridL));
            this._maskArea.graphics.lineTo(this.x2pixelsL(this._xMinGridL),  this.y2pixelsL(this._yMaxGridL));
            this._maskArea.graphics.lineTo(this.x2pixelsL(this._xMaxGridL),  this.y2pixelsL(this._yMaxGridL));
            this._maskArea.graphics.lineTo(this.x2pixelsL(this._xMaxGridL),  this.y2pixelsL(this._yMinGridL));
            this._maskArea.graphics.lineTo(this.x2pixelsL(this._xMinGridL),  this.y2pixelsL(this._yMinGridL));
        }
    }
    private drawMarkers(){
        //console.log("In drawMarkers");
        for (let i=0; i<this._markerShape.length; i++){
            switch (this._markerStyle[i] ){
                case "diamond":
                    this._markerShape[i].graphics.clear();
                    this._markerShape[i].graphics.beginFill(this._markerColor[i]);
                    this._markerShape[i].graphics.moveTo(-this._markerSize[i]/2, 0);
                    this._markerShape[i].graphics.lineTo( 0, -this._markerSize[i]/2);
                    this._markerShape[i].graphics.lineTo( this._markerSize[i]/2, 0);
                    this._markerShape[i].graphics.lineTo( 0, this._markerSize[i]/2);
                    this._markerShape[i].graphics.lineTo(-this._markerSize[i]/2, 0);
                    this._markerShape[i].visible = this._markerVisible[i] && this._showMarkers;
                    break;
                case "+":
                    this._markerShape[i].graphics.clear();
                    this._markerShape[i].graphics.setStrokeStyle(this._markerSize[i]/5);
                    this._markerShape[i].graphics.beginStroke( this._markerColor[i]);
                    this._markerShape[i].graphics.moveTo(-this._markerSize[i]/2, 0);
                    this._markerShape[i].graphics.lineTo( this._markerSize[i]/2, 0);
                    this._markerShape[i].graphics.moveTo( 0, -this._markerSize[i]/2);
                    this._markerShape[i].graphics.lineTo( 0,  this._markerSize[i]/2);
                    this._markerShape[i].visible = this._markerVisible[i] && this._showMarkers;
                    break;
                case "X":
                    this._markerShape[i].graphics.clear();
                    this._markerShape[i].graphics.setStrokeStyle(this._markerSize[i]/5);
                    this._markerShape[i].graphics.beginStroke( this._markerColor[i]);
                    this._markerShape[i].graphics.moveTo(-this._markerSize[i]/2, -this._markerSize[i]/2);
                    this._markerShape[i].graphics.lineTo( this._markerSize[i]/2, this._markerSize[i]/2);
                    this._markerShape[i].graphics.moveTo( -this._markerSize[i]/2, this._markerSize[i]/2);
                    this._markerShape[i].graphics.lineTo( this._markerSize[i]/2,  -this._markerSize[i]/2);
                    this._markerShape[i].visible = this._markerVisible[i] && this._showMarkers;
                    break;
                default:
                    console.log("ERROR in XYplot.ts - invalid markerStyle "+this._markerStyle[i])
                    break;
            }
            this._markerLabel[i].text = this._markerLabelText[i];
            this._markerLabel[i].visible = this._markerLabelVisible[i];
            this._markerLabel[i].font = this._markerLabelFont;
            this._markerLabel[i].color = this._markerLabelColor;
            this._markerLabel[i].rotation = this._markerLabelRotation;
            

        }
        
    }

    public setCurveColor(i, color){
        this.curveColor[i] = UtilSP.c2rgba(color);
    }
    private drawGridlines(){
        //console.log("In drawGridlines, this._xGridSpacingL = "+this._xGridSpacingL)
        let xx:number;
        let yy:number;

        this.xGridLinesL.graphics.clear();
        this.yGridLinesL.graphics.clear();
        this.xGridLinesR.graphics.clear();
        this.yGridLinesR.graphics.clear();

        let xAxisYinterceptL:number = 0;
        let yAxisXinterceptL:number = 0;
        let axisLineWeightLight:number = 1;
        let axisLineWeightHeavy:number = 4;

        if (this._showXGridLinesL){
            this.xGridLinesL.graphics.beginStroke(this._gridLineColorL);
            for (xx=this._xMinGridL; xx<=this._xMaxGridL; xx+=this._xGridSpacingL){
                //console.log(this._xMinGridL+"  "+xx+"  "+this._xMaxGridL);
                if (xx == yAxisXinterceptL){
                    this.xGridLinesL.graphics.setStrokeStyle(axisLineWeightHeavy);
                } else {
                    this.xGridLinesL.graphics.setStrokeStyle(axisLineWeightLight);
                }
                this.xGridLinesL.graphics.moveTo(this.x2pixelsL(xx),  this.y2pixelsL(this._yMinGridL));
                this.xGridLinesL.graphics.lineTo(this.x2pixelsL(xx),  this.y2pixelsL(this._yMaxGridL));
            }
        }
        if (this._showXGridLinesR){
            this.xGridLinesR.graphics.setStrokeStyle(1);
            this.xGridLinesR.graphics.beginStroke(this._gridLineColorR);
            for (xx=this._xMinGridR; xx<=this._xMaxGridR; xx+=this._xGridSpacingR){
                //console.log(this._xMinGridR+"  "+xx+"  "+this._xMaxGridR);
                this.xGridLinesR.graphics.moveTo(this.x2pixelsR(xx),  this.y2pixelsR(this._yMinGridR));
                this.xGridLinesR.graphics.lineTo(this.x2pixelsR(xx),  this.y2pixelsR(this._yMaxGridR));
            }
        }        
        if (this._showYGridLinesL){
            this.yGridLinesL.graphics.setStrokeStyle(1);
            this.yGridLinesL.graphics.beginStroke(this._gridLineColorL);
            for (let yy=this._yMinGridL; yy<=this._yMaxGridL; yy+=this._yGridSpacingL){
                if (yy == xAxisYinterceptL){
                    this.yGridLinesL.graphics.setStrokeStyle(axisLineWeightHeavy);
                } else {
                    this.yGridLinesL.graphics.setStrokeStyle(axisLineWeightLight);
                }
                this.yGridLinesL.graphics.moveTo(this.x2pixelsL(this._xMinGridL),  this.y2pixelsL(yy));
                this.yGridLinesL.graphics.lineTo(this.x2pixelsL(this._xMaxGridL),  this.y2pixelsL(yy));
            }
        }
        if (this._showYGridLinesR){
            this.yGridLinesR.graphics.setStrokeStyle(1);
            this.yGridLinesR.graphics.beginStroke(this._gridLineColorR);
            for (let yy=this._yMinGridR; yy<=this._yMaxGridR; yy+=this._yGridSpacingR){
                //console.log(_yMinGridR+"  "+yy+"  "+_yMaxGridR);
                this.yGridLinesR.graphics.moveTo(this.x2pixelsR(this._xMinGridR),  this.y2pixelsR(yy));
                this.yGridLinesR.graphics.lineTo(this.x2pixelsR(this._xMaxGridR),  this.y2pixelsR(yy));
            }
        }        
    }
    private writeLegends(){
        this.legendsArea.removeAllChildren(); // Wipe out the whole area and start over
/*
        let arialFont:Font = new ArialRegularEmbedded();
        let legendFormat:TextFormat = new TextFormat(); //"Arial", 20);
        legendFormat.font = arialFont.fontName;
        legendFormat.size = this._legendFontSize;
        legendFormat.align = "center";

        let yAxisValueLabelsFormat:TextFormat = new TextFormat(); //"Arial", 20);
        yAxisValueLabelsFormat.font = arialFont.fontName;
        yAxisValueLabelsFormat.size = _legendFontSize;
        yAxisValueLabelsFormat.align = TextFormatAlign.RIGHT;
*/
        let i:number;
        let h:number;

        let textBoxes:createjs.Shape = new this.createjs.Shape();
        if (this._showTextBoxes){
            this.legendsArea.addChild(textBoxes);
        }
        textBoxes.graphics.clear();
        textBoxes.graphics.setStrokeStyle(2).beginStroke("red" );

        //Make texts and get sizes
        this.xAxisLegendL = new createjs.Text();
        this.legendsArea.addChild(this.xAxisLegendL);
        this.xAxisLegendL.textAlign = "center";
        this.xAxisLegendL.font = this._legendFont;
        this.xAxisLegendL.text = this._xAxisLegendTextL;
        let _xAxisLegendHeightL:number = this.xAxisLegendL.getMeasuredHeight();            

        this.xAxisLegendR = new createjs.Text();
        this.legendsArea.addChild(this.xAxisLegendR);
        this.xAxisLegendR.textAlign = "center";
        this.xAxisLegendR.font = this._legendFont;
        this.xAxisLegendR.text = this._xAxisLegendTextR;
        let _xAxisLegendHeightR:number = this.xAxisLegendR.getMeasuredHeight();            


        // Y axis left ---------------------------------------------------------------------
        this.yAxisLegendL = new createjs.Text();
        this.legendsArea.addChild(this.yAxisLegendL);
        this.yAxisLegendL.textAlign = "center"; 
        this.yAxisLegendL.font = this._legendFont;
        this.yAxisLegendL.text = this._yAxisLegendTextL; 
        let _yAxisLegendHeightL:number = this.yAxisLegendL.getMeasuredHeight();    
        let _yAxisValueLabelsLX = this._xPixelsMin - this._yAxisValueLabelsWidthL - 5; // Left justified
        let _yAxisLegendLX:number;
        
        if (this._showYAxisValueLabelsL){
            _yAxisLegendLX = _yAxisValueLabelsLX - _yAxisLegendHeightL - 5;
        }else {
            _yAxisLegendLX = this._xPixelsMin - _yAxisLegendHeightL - 5;
        }

        this.yAxisLegendL.visible = this._showYAxisLegendL && (this._yAxisLegendTextL.length > 0);
        this.yAxisLegendL.x = _yAxisLegendLX; //_xPixelsMin - _yAxisLegendHeight; //(_xPixelsMax+_xPixelsMin)/2;
        this.yAxisLegendL.y = (this._yPixelsMax+this._yPixelsMin)/2; //this._yPixelsMin + 30;
        this.yAxisLegendL.rotation = -90;

        if (this._showYAxisValueLabelsL){
            let yAxisValueLabelsL:Array<createjs.Text> = [];
            //_yMinGridL = _yValueLabelSpacingL*Math.ceil(_yMinL/_yValueLabelSpacingL);
            //_yMaxGridL = _yValueLabelSpacingL*Math.floor(_yMaxL/_yValueLabelSpacingL);
            i=0;
            //let fmtYString = "%"+_yValueLabelFormat+"f";
            for (let yy=this._yMinGridL; yy<=this._yMaxGridL; yy+=this._yValueLabelSpacingL){
                yAxisValueLabelsL[i] = new createjs.Text();
                this.legendsArea.addChild(yAxisValueLabelsL[i]);
                yAxisValueLabelsL[i].text = yy.toFixed(this._yLabelsDecimalPlacesL);
                h = yAxisValueLabelsL[i].getMeasuredHeight(); 
                yAxisValueLabelsL[i].textAlign = "left";
                yAxisValueLabelsL[i].x = _yAxisValueLabelsLX;
                yAxisValueLabelsL[i].y = this.y2pixelsL(yy) - h/2; //// - yAxisValueLabelsL[i].height/2;
                yAxisValueLabelsL[i].font = this._labelsFont;
                //console.log(i+": "+yAxisValueLabelsL[i].text+", x = "+_yAxisValueLabelsLLX+", width = "+_yAxisValueLabelsLWidthL);
                i++;
            }
        }
        textBoxes.graphics.drawRect(_yAxisValueLabelsLX, this._yPixelsMax, this._yAxisValueLabelsWidthL, this._yPixelsMin-this._yPixelsMax);
        textBoxes.graphics.setStrokeStyle(2).beginStroke("red" );
        textBoxes.graphics.drawRect(_yAxisLegendLX, this._yPixelsMax, _yAxisLegendHeightL, this._yPixelsMin-this._yPixelsMax);
        textBoxes.graphics.setStrokeStyle(2).beginStroke("blue" );   

        // Y axis right ---------------------------------------------------------------------
        this.yAxisLegendR = new createjs.Text();
        this.legendsArea.addChild(this.yAxisLegendR);
        this.yAxisLegendR.textAlign = "center"; 
        this.yAxisLegendR.font = this._legendFont;
        this.yAxisLegendR.text = this._yAxisLegendTextR; 
        this.yAxisLegendR.text = this._yAxisLegendTextR; 
        let _yAxisLegendHeightR:number = this.yAxisLegendR.getMeasuredHeight();    
        let _yAxisValueLabelsRX:number = this._xPixelsMax + 10; // + _yAxisValueLabelsWidthR; 
        let _yAxisLegendRX:number;

        if (this._showYAxisValueLabelsR){
            _yAxisLegendRX = _yAxisValueLabelsRX + this._yAxisValueLabelsWidthR+ this._yAxisLegendHeightR;   ///10 + this._xPixelsMax - _yAxisValueLabelsWidthR - _yAxisLegendHeightR; /////
        }else {
            _yAxisLegendRX = 10 + this._xPixelsMax ; /////
        }
        this.yAxisLegendR.visible = this._showYAxisLegendR && (this._yAxisLegendTextR.length > 0);
        this.yAxisLegendR.x = _yAxisLegendRX; //_xPixelsMin - _yAxisLegendHeight; //(_xPixelsMax+_xPixelsMin)/2;
        this.yAxisLegendR.y = (this._yPixelsMax+this._yPixelsMin)/2; //this._yPixelsMin + 30;
        this.yAxisLegendR.rotation = -90;

        if (this._showYAxisValueLabelsR){
            let yAxisValueLabelsR:Array<createjs.Text> = [];
            //_yMinGridL = _yValueLabelSpacingL*Math.ceil(_yMinL/_yValueLabelSpacingL);
            //_yMaxGridL = _yValueLabelSpacingL*Math.floor(_yMaxL/_yValueLabelSpacingL);
            i=0;
            //let fmtYString = "%"+_yValueLabelFormat+"f";
            for (let yy=this._yMinGridR; yy<=this._yMaxGridR; yy+=this._yValueLabelSpacingR){
                yAxisValueLabelsR[i] = new createjs.Text();
                this.legendsArea.addChild(yAxisValueLabelsR[i]);
                yAxisValueLabelsR[i].text = yy.toFixed(this._yLabelsDecimalPlacesR);
                h = yAxisValueLabelsR[i].getMeasuredHeight(); 
                yAxisValueLabelsR[i].textAlign = "left";
                yAxisValueLabelsR[i].x = _yAxisValueLabelsRX;
                yAxisValueLabelsR[i].y = this.y2pixelsR(yy) - h/2; //// - yAxisValueLabelsL[i].height/2;
                yAxisValueLabelsR[i].font = this._labelsFont;
                //console.log(i+": "+yAxisValueLabelsL[i].text+", x = "+_yAxisValueLabelsLLX+", width = "+_yAxisValueLabelsLWidthL);
                i++;
            }
        }  
        textBoxes.graphics.drawRect(_yAxisValueLabelsRX, this._yPixelsMax, this._yAxisValueLabelsWidthR, this._yPixelsMin-this._yPixelsMax);
        textBoxes.graphics.setStrokeStyle(2).beginStroke("red" );
        textBoxes.graphics.drawRect(_yAxisLegendRX, this._yPixelsMax, _yAxisLegendHeightR, this._yPixelsMin-this._yPixelsMax);
        textBoxes.graphics.setStrokeStyle(2).beginStroke("blue" );  

        // X axis left ---------------------------------------------------------------------
        this.xAxisLegendL.visible = this._showXAxisLegendL && (this._xAxisLegendTextL.length > 0);
        this.xAxisLegendL.x = (this._xPixelsMax+this._xPixelsMin)/2;
        this.xAxisLegendL.y = this._yPixelsMin+this._xAxisLegendHeight;
            
        if (this._showXAxisValueLabelsL){
            this.xAxisValueLabelsL = [];
            ///_xMinGridL = _xValueLabelSpacingL*Math.ceil(_xMinL/_xValueLabelSpacingL);
            ///_xMaxGridL = _xValueLabelSpacingL*Math.floor(_xMaxL/_xValueLabelSpacingL);
            i=0;
            //let spacingPixelsL:number = this.x2pixelsL(this._xMinGridL+this._xValueLabelSpacingL) -  this.x2pixelsL(this._xMinGridL);
            //console.log("spacingPixels = "+spacingPixels);
            //let fmtXString = "%"+_xValueLabelFormat+"f";
            for (let xx:number = this._xMinGridL; xx<=this._xMaxGridL; xx+=this._xValueLabelSpacingL){
                this.xAxisValueLabelsL[i] = new createjs.Text();
                this.legendsArea.addChild(this.xAxisValueLabelsL[i]); //// May be wrong
                this.xAxisValueLabelsL[i].text =  xx.toFixed(this._xLabelsDecimalPlacesL);
                this.xAxisValueLabelsL[i].textAlign = "center";
                this.xAxisValueLabelsL[i].x = this.x2pixelsL(xx); 
                this.xAxisValueLabelsL[i].y = this.y2pixelsL(this._yMinGridL)+10;
                this.xAxisValueLabelsL[i].font = this._labelsFont;
                //console.log(i+": "+xAxisValueLabelsL[i].text+"  fmt = "+fmtXString+", xx = "+x2pixelsL(xx)+", width = "+xAxisValueLabelsL[i].width);
                i++;
            }
        }
        // X axis right ---------------------------------------------------------------------
        this.xAxisLegendR.visible = this._showXAxisLegendR && (this._xAxisLegendTextR.length > 0);
        this.xAxisLegendR.x = (this._xPixelsMax+this._xPixelsMin)/2;
        this.xAxisLegendR.y = this._yPixelsMin+20 + 20; /////

        if (this._showXAxisValueLabelsR){
            this.xAxisValueLabelsR = [];
            ///_xMinGridL = _xValueLabelSpacingL*Math.ceil(_xMinL/_xValueLabelSpacingL);
            ///_xMaxGridL = _xValueLabelSpacingL*Math.floor(_xMaxL/_xValueLabelSpacingL);
            i=0;
            //let spacingPixelsR:number = this.x2pixelsR(this._xMinGridR+this._xValueLabelSpacingR) -  this.x2pixelsR(this._xMinGridR);
            //console.log("spacingPixels = "+spacingPixels);
            //let fmtXString = "%"+_xValueLabelFormat+"f";
            for (let xx:number = this._xMinGridR; xx<=this._xMaxGridR; xx+=this._xValueLabelSpacingR){
                this.xAxisValueLabelsR[i] = new createjs.Text();
                this.legendsArea.addChild(this.xAxisValueLabelsR[i]); //// May be wrong
                this.xAxisValueLabelsR[i].text =  xx.toFixed(this._xLabelsDecimalPlacesR);
                this.xAxisValueLabelsR[i].textAlign = "center";
                this.xAxisValueLabelsR[i].x = this.x2pixelsR(xx); 
                this.xAxisValueLabelsR[i].y = this.y2pixelsR(this._yMinGridR)+2;
                this.xAxisValueLabelsR[i].font = this._labelsFont;
                //console.log(i+": "+xAxisValueLabelsL[i].text+"  fmt = "+fmtXString+", xx = "+x2pixelsL(xx)+", width = "+xAxisValueLabelsL[i].width);
                i++;
            }
        }        

      
        // Curve legends ---------------------------------------------------------------------
        let curveLegends:Array<createjs.Text> = [];
        for (i=0; i<this._curveLegendText.length; i++){
            curveLegends[i] = new createjs.Text();
            this.legendsArea.addChild(curveLegends[i]);
            curveLegends[i].x = this.x2pixelsL(this._curveLegendX[i]); //// - curveLegends[i].width/2;
            curveLegends[i].y = this.y2pixelsL(this._curveLegendY[i]);
            curveLegends[i].text = this._curveLegendText[i];
            curveLegends[i].font = this._legendFont;
            curveLegends[i].color = this._curveLegendColor[i]; //"red"; ////
            curveLegends[i].visible = this._showCurveLegends;
            //console.log("_curveLegendText i = "+i+", color = ", this._curveLegendColor[i]);
            
        }

    }
    public doEveryFrame(){
        this.scope.doEveryFrame();
    }
    public clearCurve(iCurve){
        //debugger;
        if (iCurve < this.curves.length){
            this.curves[iCurve].graphics.clear();
        } else {
            console.log("WARNING from XYPlot clearCurve: iCurve exceeds length of curves")
        }
    }
    public setMarkerX(im,xx){
        this._markerX[im] = xx;
        this.updateMarkers();
    }
    public getMarkerX(im){ return this._markerX[im];};
    
    public setMarkerY(im,yy){
        this._markerY[im] = yy;
        this.updateMarkers();
    }
    public getMarkerY(im){ return this._markerY[im];};
    
    public setMarkerXY(im,xx,yy){
        this._markerX[im] = xx;
        this._markerY[im] = yy;
        this.updateMarkers();
    }

    public hideAllMarkers(){
        for (let i=0; i<this._markerShape.length; i++){
            this._markerVisible[i] = false;
        }
        this.updateMarkers();
    }
    public setMarkerVisible(im, vis){
        this._markerVisible[im] = vis;
        this.updateMarkers();
    }
    public getMarkerVisible(im){
        return this._markerVisible[im];
    }
    public setMarkerColor(im, col){
        this._markerColor[im] = UtilSP.c2rgba(col);
        this.drawMarkers();
        this.updateMarkers();
    }
    public getMarkerColor(im){
        return this._markerColor[im];
    }
    public setMarkerStyle(im:number, val:string){
        this._markerStyle[im] = val;
        this.drawMarkers();
        this.updateMarkers();
    }
    public getMarkerStyle(im){
        return this._markerStyle[im];
    }
    public setMarkerSize(im:number, val:number){
        this._markerSize[im] = val;
        this.drawMarkers();
        this.updateMarkers();
    }
    public getMarkerSize(im){
        return this._markerSize[im];
    }
    public setMarkerLabelText(im:number, val:string){
        this._markerLabelText[im] = val;
        this.drawMarkers();
        this.updateMarkers();        
    }
    
    public setMarkerLabelVisible(im:number, val:boolean){
        this._markerLabelVisible[im] = val;
        this.drawMarkers();
        this.updateMarkers();        
    }
    public hideAllMarkerLabels(){
        for (let i=0; i<this._markerShape.length; i++){
            this._markerLabelVisible[i] = false;
        }
        this.drawMarkers();
        this.updateMarkers();
    }
    public set markerLabelFont(val:string){
        this._markerLabelFont = val;
        this.drawMarkers();
        this.updateMarkers();           
    }
    public get markerLabelFont():string{
        return this._markerLabelFont;
    }
    public set markerLabelColor(val:string){
        this._markerLabelColor = val;
        this.drawMarkers();
        this.updateMarkers();           
    }
    public get markerLabelColor():string{
        return this._markerLabelColor;
    }    
    public set markerLabelRotation(val:number){
        this._markerLabelRotation = val;
        this.drawMarkers();
        this.updateMarkers();           
    }
    public get markerLabelRotation():number{
        return this._markerLabelRotation;
    }  
    public set xAxisLegendText(t){
        this._xAxisLegendTextL = t;
        this.writeLegends();
    }
    public get xAxisLegendText(){ return this._xAxisLegendTextL; };

    public set xAxisLegendTextR(t){
        this._xAxisLegendTextR = t;
        this.writeLegends();
    }

    public get xAxisLegendTextR(){ return this._xAxisLegendTextR; };
    
    public set xAxisLegendHeight(val:number){
        this._xAxisLegendHeight = val;
        this.writeLegends();
    }
    public get xAxisLegendHeight():number{ return this._xAxisLegendHeight; };

    public set yAxisLegendText(t){
        this._yAxisLegendTextL = t;
        this.writeLegends();
    }
    public get yAxisLegendText(){ return this._yAxisLegendTextL; };

    public set yAxisLegendTextR(t){
        this._yAxisLegendTextR = t;
        this.writeLegends();
    }
    public get yAxisLegendTextR(){ return this._yAxisLegendTextR; };

    public set showXAxisValueLabels(val){
        this._showXAxisValueLabelsL = val;
        this.writeLegends();
    }
    public get showXAxisValueLabels(){
        return this._showXAxisValueLabelsL;
    }
    public set showYAxisValueLabels(val){
        this._showYAxisValueLabelsL = val;
        this.writeLegends();
    }
    public get showYAxisValueLabels(){
        return this._showYAxisValueLabelsL;
    }
    public set showYAxisValueLabelsR(val){
        this._showYAxisValueLabelsR = val;
        this.writeLegends();
    }
    public get showYAxisValueLabelsR(){
        return this._showYAxisValueLabelsR;
    }


    public set showXAxisLegend(val){
        this._showXAxisLegendL = val;
        this.writeLegends();
    }
    public get showXAxisLegend(){
        return this._showXAxisLegendL;
    }
    public set showYAxisLegend(val){
        this._showYAxisLegendL = val;
        this.writeLegends();
    }
    public get showYAxisLegend(){
        return this._showYAxisLegendL;
    }
    
    public set showXAxisLegendR(val){
        this._showXAxisLegendR = val;
        this.writeLegends();
    }
    public get showXAxisLegendR(){
        return this._showXAxisLegendR;
    }
    public set showYAxisLegendR(val){
        this._showYAxisLegendR = val;
        this.writeLegends();
    }
    public get showYAxisLegendR(){
        return this._showYAxisLegendR;
    }

    public set legendFontSize(val){
        this._legendFontSize = val;
        this.writeLegends();
    }
    public get legendFontSize(){
        return this._legendFontSize;
    }		
    public set showLines(val:boolean){
        this._showLines = val;
    }
    public get showLines():boolean{
        return this._showLines;
    }
    public set showSymbols(val:boolean){
        this._showSymbols = val;
    }
    public get showSymbols():boolean{
        return this._showSymbols;
    }
    public setCurveStyle(iC, style){
        this._curveStyle[iC] = style;
    }
    public set curveThickness(val){
        this._curveThicknessL = val;
    }
    public get curveThickness(){
        return this._curveThicknessL;
    }
    public set curveThicknessL(val){
        this._curveThicknessL = val;
    }
    public get curveThicknessL(){
        return this._curveThicknessL;
    }    
    public set curveThicknessR(val){
        this._curveThicknessR = val;
    }
    public get curveThicknessR(){
        return this._curveThicknessR;
    }    
    public setCurveVisible(ic:number, vis:boolean){
        this.curves[ic].visible = vis;
    }
    public getxValues(ic):Array<number>{
        return this._xValues[ic];
    }
    public getyValues(ic):Array<number>{
        return this._yValues[ic];
    }
    public set curveIsOnLeft(arr:Array<boolean>){
        for (let i:number = 0; i<arr.length; i++){
            this._curveIsOnLeft[i] = arr[i]
            this.drawCurve(i);
        }
    }
    public set markerIsOnLeft(arr:Array<boolean>){
        for (let i:number = 0; i<arr.length; i++){
            this._markerIsOnLeft[i] = arr[i]
            this.updateMarkers();
        }
    } 
    public set yAxisValueLabelsWidth(val:number){
        this._yAxisValueLabelsWidthL = val;
        this.writeLegends();
    }
    public get yAxisValueLabelsWidth(){
        return this._yAxisValueLabelsWidthL;
    }       
    public set yAxisValueLabelsWidthR(val:number){
        this._yAxisValueLabelsWidthR = val;
        this.writeLegends();
    }
    public get yAxisValueLabelsWidthR(){
        return this._yAxisValueLabelsWidthR;
    }

    public set showCurveLegends(val:boolean){
        this._showCurveLegends = val;
        this.writeLegends();
    }
    public get showCurveLegends(){
        return this._showCurveLegends;
    }
    public set showMarkers(val:boolean){
        this._showMarkers = val;
        this.updateMarkers();
    }
    public get showMarkers(){
        return this._showMarkers;
    }    
}

